// support/api.js
import API from "common-ui-components/components/utils/API";

const SUPPORT_MAIL_ENDPOINT = "/inventory/sendSupportMail";

export const MAIL_TYPE = {
  CONTACT_SUPPORT: "CONTACT_SUPPORT",
  REQUEST_DEMO: "REQUEST_DEMO",
  FEATURE_REQUEST: "FEATURE_REQUEST",
};

export const normalizePhone = (value) => {
  if (!value) return null;
  const digits = String(value).replace(/\D/g, "");
  return digits ? `+${digits.slice(0, 2)} ${digits.slice(2)}` : null;
};

export const sendSupportMail = async ({ mailType, payload, attachment }) => {
  const dto = { mailType, ...payload };

  const formData = new FormData();
  formData.append(
    "sendSupportMailDTO",
    new Blob([JSON.stringify(dto)], { type: "application/json" }),
  );
  if (attachment) {
    formData.append("attachment", attachment);
  }

  const response = await API.post(SUPPORT_MAIL_ENDPOINT, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response?.data ?? null;
};
